import { useCallback, useState } from 'react';

import { isPropControlled } from '../helpers';
import { DatePickerArgs, UpdateActiveMonths } from '../types';

function useDateSelection({
  initialDate,
  propsDate,
  propsOnChange,
  onFinalSelection,
  setShouldShowSelection,
}: {
  initialDate?: DatePickerArgs['initialValue'];
  propsDate?: DatePickerArgs['value'];
  propsOnChange?: DatePickerArgs['onChange'];
  onFinalSelection: () => void;
  setShouldShowSelection?: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [stateDate, setStateDate] = useState(initialDate);

  const isDateControlled = isPropControlled(propsDate);
  const date = isDateControlled ? propsDate : stateDate;

  const onDateSelected = useCallback(
    (
      {
        selectable,
        date: newlySelectedDate,
      }: { selectable?: boolean; date: Date },
      updateActiveMonths: UpdateActiveMonths,
    ) => {
      if (!selectable) {
        return;
      }
      if (!isDateControlled) {
        setStateDate(newlySelectedDate);
      }
      setShouldShowSelection?.(true);
      propsOnChange?.({ date: newlySelectedDate });
      updateActiveMonths(false, newlySelectedDate);
      onFinalSelection();
    },
    [isDateControlled, propsOnChange, onFinalSelection, setShouldShowSelection],
  );

  const resetSelection = useCallback(() => {
    if (!isDateControlled) {
      setStateDate(null);
    }
    propsOnChange?.({ date: null });
  }, [isDateControlled, propsOnChange]);

  return {
    date,
    onDateSelected,
    resetSelection,
  };
}

export default useDateSelection;
